function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyArticle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 121,
  height: 111,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE040",
  fillRule: "evenodd",
  d: "M42.206 101.523c23.31 0 42.206-15.34 42.206-34.262S65.516 33 42.206 33 0 48.34 0 67.261c0 8.755 4.045 16.743 10.701 22.8l-2.529 20.738 16.457-12.38c5.351 1.993 11.304 3.104 17.577 3.104",
  clipRule: "evenodd",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4690FF",
  fillRule: "evenodd",
  d: "M92.21 91.8C76.63 91.8 64 81.547 64 68.9S76.63 46 92.21 46s28.21 10.253 28.21 22.9c0 5.851-2.704 11.19-7.152 15.238L114.958 98l-11-8.275c-3.577 1.332-7.555 2.075-11.748 2.075",
  clipRule: "evenodd",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EB3737",
  fillRule: "evenodd",
  d: "M24.5 16.726c11.874 0 21.5 7.814 21.5 17.453S36.374 51.63 24.5 51.63 3 43.818 3 34.18c0-4.46 2.06-8.53 5.451-11.615L7.163 12l8.383 6.306c2.726-1.015 5.759-1.58 8.954-1.58",
  clipRule: "evenodd",
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B55E",
  fillRule: "evenodd",
  d: "M63.706 7.628C44.538 7.628 29 20.242 29 35.801c0 15.56 15.538 28.173 34.706 28.173s34.706-12.613 34.706-28.173c0-7.199-3.327-13.768-8.8-18.748L91.692 0 78.159 10.18c-4.4-1.639-9.295-2.552-14.453-2.552",
  clipRule: "evenodd",
  style: {
    mixBlendMode: "multiply"
  }
}));
export default SvgEmptyArticle;